export const settingsLabels: Record<string, string> = {
  hotelTypes: 'Viešbučių tipai',
  serviceTypes: 'Paslaugų tipai',
  eventTypes: 'Renginių tipai',
  towns: 'Miestai'
};
